import React from "react";
import styled from "styled-components";

const Collaboration = ({ children }) => (
  <StyledCollaboration>
    <span>{children}</span>
  </StyledCollaboration>
);

export default Collaboration;

const StyledCollaboration = styled.aside`
  position: relative;
  margin: calc(2 * var(--text-size)) auto;
  max-width: var(--text-max-width);
  padding: calc(1.25 * var(--text-size)) 0 var(--text-size);
  &::before,
  &::after {
    content: '';
    position: absolute;
    right: 0;
    left: 0;
    height: 1px;
    background-color: currentColor;
    opacity: 0.2;
  }
  &::before {
    top: 0;
  }
  &::after {
    bottom: 0;
  }
  span {
    display: block;
    margin: 0 auto;
    font-size: 1.125em;
    font-style: italic;
    font-family: var(--font-serif);
    text-align: center;
    max-width: 20em;
    line-height: 1.5;
    a {
      text-decoration-line: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.125em;
      text-decoration-color: var(--theme-text-against-dark-medium);
      .can-hover &:hover,
      &:active {
        text-decoration-color: currentColor;
      }
    }
  }
  @media ( min-width: 48em ) {
    span {
      font-size: 1.25em;
    }
  }
`